import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { FilterSearchingEmpresaDeshidratadoraViewModel, EmpresaDeshidratadoraItemResultsViewModel } from '../empresadeshidratadora.types';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, FilterSearchingBaseViewModel, ListSiNoTodos, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { EmpresaDeshidratadoraService } from '../empresadeshidratadora.service';
import { DialogMode } from 'src/app/components/_campanias/types/enum';
import { TwSolicitudCamViewModelBase } from 'src/app/components/_campanias/types/solicitudcam-datosbasicos.types';
import { CampaniaBase } from 'src/app/components/_campanias/types/campaniaBase';
import { Mixin } from 'ts-mixer';
import { catchError, of, tap } from 'rxjs';
import { CampaniasService } from 'src/app/components/core/_infrastructure/classes/services/campanias-global.service';
import { EmpresaDeshidratadoraDesautorizadaCamService } from '../empresadeshidratadora-desautorizada-cam.service';
import { AutorizarRecintoPIAEDCamViewModel } from 'src/app/components/_campanias/types/common-cam-types';

@Component({
    selector: 'app-empresadeshidratadora-wrapper',
    templateUrl: './empresadeshidratadora-wrapper.component.html',
    styleUrls: ['./empresadeshidratadora-wrapper.component.scss'],
})
export class EmpresadeshidratadoraWrapperComponent extends Mixin(ComponentBase, CampaniaBase) implements OnInit, OnChanges {
    @Input() mode: DialogMode;
    @Input() dialogFilter: TwSolicitudCamViewModelBase;
    @Output() selectedEmpresas = new EventEmitter<any>();

    visibilitySpinner = false;
    visibilityExportSpinner = false;
    searching = false;
    provincias: Tc[];
    municipios: Tc[];

    result: EmpresaDeshidratadoraItemResultsViewModel | null;
    payload?: FilterSearchingEmpresaDeshidratadoraViewModel;

    dialogMode = DialogMode;
    listActivos = ListSiNoTodos;

    private pathEmpresasDeshidratadoras = '/mantenimiento/general/empresasdeshidratadoras/';
    private ErrorMessageEmpresaNoBorrable = 'Empresa Deshidratadora vinculada a una Solicitud de Campaña en periodo activo';
    private errorMessageExcel = 'Se ha producido un error en el servidor. Vuelta a intentarlo más tarde';
    private successMessage = 'Empresa Deshidratadora eliminada correctamente';
    private successAuthorizeMessage = 'Empresa Deshidratadora autorizada correctamente';

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        protected globalService: GlobalService,
        protected campaniasService: CampaniasService,
        private empresaDeshidratadoraService: EmpresaDeshidratadoraService,
        private empresaDeshidratadoraDesautorizadaCamService: EmpresaDeshidratadoraDesautorizadaCamService,
        private router: Router,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        if (this.mode === DialogMode.Dialog) {
            this.listActivos = this.listActivos.filter(x => x.value === EnumSiNoTodos.SI);
        } else {
            this.filtroBase = null;
        }
        this.loadProvincias();
        this.recoverLastSearch();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.dialogFilter?.currentValue && this.dialogFilter) {
            this.filtroBase = { ...this.dialogFilter }; // Pasamos los datos del input al objeto usado por la herencia
        }
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch(): void {
        this.payload = this.empresaDeshidratadoraService.getLastSearch();
    }

    /**
     * Respond to the action of searching on empresadeshidratadora-filter.
     * It will send the filter to the backend and set the response.
     * @param payload FilterSearchingEmpresaDeshidratadoraViewModel
     * @return void
     */
    onSearch(payload: FilterSearchingEmpresaDeshidratadoraViewModel): void {
        this.payload = {
            ...payload,
        } as FilterSearchingEmpresaDeshidratadoraViewModel; // To keep a copy to be used in the lazy search (paginator)

        if (this.mode === DialogMode.Dialog) {
            // En éste caso filtramos además por Periodo (por las provincias configuradas para el periodo).
            // NO aparecerán las de la propia solicitud.
            this.payload.IdPeriodoCam = this.filtroBase?.IdPeriodoCam;
            this.payload.IdCa = this.filtroBase?.IdCa;
            this.payload.IdSolicitudCam = this.filtroBase?.Id;
            this.payload.Autorizada = EnumSiNoTodos.SI;
            this.payload.IdCampania = this.filtroBase?.IdCampania;
        }

        this.loading = true;
        this.searching = true;
        this.visibilitySpinner = true;

        this.empresaDeshidratadoraService
            .getEmpresaDeshidratadoraPagedByFilter(this.payload)
            .pipe(
                tap(results => {
                    this.result = results;
                    this.searching = true;
                    this.visibilitySpinner = false;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingEmpresaDeshidratadoraViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset($event: any): void {
        this.searching = false;
        this.payload = new FilterSearchingEmpresaDeshidratadoraViewModel();
        this.empresaDeshidratadoraService.clearLastSearch();
        this.result = null;
        this.municipios = [];
    }

    /**
     * Redirigimos al formulario de creación de una nueva Empresa Deshidratadora
     * @return void
     */
    onAdd(): void {
        this.router.navigate([this.pathEmpresasDeshidratadoras + 'create']);
    }

    /**
     * Redirigimos al formulario de edición de la empresa deshidratadora.
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onEdit(itemId: number | null): void {
        if (!itemId) {
            return;
        }
        this.router.navigate([this.pathEmpresasDeshidratadoras + 'edit', itemId]);
    }

    /**
     * Redirigimos al formulario de visualización del detalle de la empresa deshidratadora.
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onView(itemId: number | null): void {
        if (!itemId) {
            return;
        }
        this.router.navigate([this.pathEmpresasDeshidratadoras + 'view', itemId]);
    }

    onDelete(itemId: number | null): void {
        if (!itemId) {
            return;
        }
        switch (this.mode) {
            case DialogMode.Basic:
                this.confirmDeletion(itemId);
                break;
        }
    }

    private confirmDeletion(itemId: number | null): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                // Actual logic to perform a confirmation
                this.empresaDeshidratadoraService.delete(itemId!).subscribe({
                    next: () => {
                        this.addSuccessMessage(this.successMessage);
                        this.onSearch(this.payload!);
                    },
                    error: err => {
                        let msg = this.ErrorMessageEmpresaNoBorrable;
                        if (err?.error?.error) {
                            msg = err?.error?.error;
                        } else if (err.error?.length > 0) {
                            if (err.error[0].message?.indexOf('está en uso') === -1) {
                                msg = err.error[0].message;
                            }
                        }
                        this.addErrorMessage(msg);
                    },
                });
            },
        });
    }

    onAuthorize(payload: AutorizarRecintoPIAEDCamViewModel): void {
        if (!payload) {
            return;
        }

        this.confirmationService.confirm({
            message: '¿Quiere volver a autorizar esta Empresa Deshidratadora en la campaña?',
            accept: () => {
                // Current logic to perform a confirmation
                this.empresaDeshidratadoraDesautorizadaCamService.authorize(payload).subscribe({
                    next: () => {
                        this.addSuccessMessage(this.successAuthorizeMessage);
                        this.onSearch(this.payload!);
                    },
                    error: () => {
                        let msg = 'No puede volver a autorizar esta Empresa Deshidratadora';
                        this.addErrorMessage(msg);
                    },
                });
            },
        });
    }

    private createModel(): FilterSearchingEmpresaDeshidratadoraViewModel {
        let model: FilterSearchingEmpresaDeshidratadoraViewModel = new FilterSearchingEmpresaDeshidratadoraViewModel();
        Object.assign(model, this.payload);
        return model;
    }

    onExportExcel(): void {
        this.visibilityExportSpinner = true;
        const model = this.createModel();
        this.empresaDeshidratadoraService.export(model).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
                this.visibilityExportSpinner = false;
            },
            error: () => this.addErrorMessage(this.errorMessageExcel),
        });
    }

    /**
     * Empresas seleccionadas en el listado
     * @param $event { selection: rowData, dblclick: dblclick }
     */
    onSelectedEmpresas($event: any): void {
        this.selectedEmpresas.emit($event);
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    get exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }
}
